"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PumpTypeEnum = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const PUMP_TYPES = ['Single Relay', 'Double Relay', 'Vibration'];
exports.PumpTypeEnum = (0, iotv_v3_types_1.getEnumShape)(PUMP_TYPES);
